import { InputNumber } from 'primereact/inputnumber';
import React from 'react';

interface EditNumberModel {
  title?: string;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  maxLength?: number;
  value?: number;
  disabled?: boolean;
  showButtons?: boolean;
}
export const EditNumber: React.FC<EditNumberModel> = ({
  title,
  onChange,
  min,
  max,
  value,
  disabled = false,
  showButtons = true,
  maxLength = 1000000000,
}) => {
  return (
    <div
      style={{
        flex: '1', // Flex-grow, flex-shrink, and base size of 250px
        minWidth: '250px', // Ensure a minimum width of 250px
        marginBottom: '16px', // Optional bottom margin for row spacing
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ fontSize: '14px', color: '#4b5563' }}>{title}</div>
      <InputNumber
        style={{ height: '36px', marginTop: '4px', direction: 'ltr' }}
        id="username"
        aria-describedby="username-help"
        min={min}
        max={max}
        maxLength={maxLength}
        value={value}
        inputStyle={{ textAlign: 'right' }} // Add this line
        showButtons={showButtons}
        onChange={(e) => onChange(e?.value ?? 0)}
        disabled={disabled}
      />
    </div>
  );
};
